import { useEffect } from "react";

export default function FAQStructuredData({ faqs }) {
  useEffect(() => {
    if (!faqs || faqs.length === 0) return;

    const existing = document.getElementById("structured-data-faq");
    if (existing) existing.remove();

    const schema = {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      "mainEntity": faqs.map(faq => ({
        "@type": "Question",
        "name": faq.question,
        "acceptedAnswer": {
          "@type": "Answer",
          "text": faq.answer
        }
      }))
    };

    const script = document.createElement("script");
    script.id = "structured-data-faq";
    script.type = "application/ld+json";
    script.text = JSON.stringify(schema);
    document.head.appendChild(script);

    return () => {
      const el = document.getElementById("structured-data-faq");
      if (el) el.remove();
    };
  }, [faqs]);

  return null;
}